import { connect } from 'react-redux'

import { doUploadFiles } from 'actions/attachments'
import { doRealtimeAgentStartTicketTypingNotification } from 'actions/realtime'
import { doMentionAgent } from 'actions/tickets'
import { doUpdateEditorVisibility } from 'ducks/editor/operations'

import {
  selectDraftIdByTicketId,
  selectDraftPropByDraftId,
  makeDraftPropOrDefaultSelector,
} from 'ducks/drafts2/selectors'
import {
  debouncedHandleDraftChange,
  handleDraftChange,
  doDeleteDraft,
  doSendReplyDraft,
  doEnsureDefaults,
} from 'ducks/drafts2/operations'

import {
  doUpdateAgentMention,
  doUpdateSuppressMentionSelector,
} from 'actions/app'

import {
  selectShowMentionSelector,
  selectIsMentioningAgent,
  selectSelectedMentionSelectorAgentId,
  selectSuppressMentionSelector,
} from 'selectors/mentions'
import { doOpenTicketPage } from 'actions/pages'

import { getAssignmentLabel } from 'components/App/DesktopView/CommunicationForms/shared/util'
import { selectRawTicket } from 'selectors/tickets/byId'
import { selectCurrentTicketIsFollowing } from 'selectors/tickets'
import View from './view'

const select = () => {
  return (state, props) => {
    const { ticketId } = props
    const ticket = selectRawTicket(state, ticketId)
    const draftId = selectDraftIdByTicketId(state, ticketId, 'note')

    const selectDraftPropByName = makeDraftPropOrDefaultSelector(
      state,
      draftId,
      ticketId
    )

    const assigneeId = selectDraftPropByName('assigneeId')
    const assigneeGroupId = selectDraftPropByName('assigneeGroupId')

    return {
      draftId,
      defaultsSet: selectDraftPropByDraftId(state, draftId, 'defaultsSet'),
      defaultsAvailable: !!ticket.draftDefaults,
      isOpen: ticket.isOpen,
      assignmentLabel: getAssignmentLabel(state, assigneeId, assigneeGroupId),
      assigneeGroupId,
      isSendable: selectDraftPropByName('isSendable'),
      showMentionSelector: selectShowMentionSelector(state),
      isMentioning: selectIsMentioningAgent(state),
      selectedMentionSelectorAgentId: selectSelectedMentionSelectorAgentId(
        state
      ),
      suppressMentionSelector: selectSuppressMentionSelector(state),
      isTicketFollowing: selectCurrentTicketIsFollowing(state),
    }
  }
}

const perform = dispatch => {
  const draftType = 'note'
  return {
    deleteDraft: (ticketId, draftId) => {
      if (draftId) {
        const msg = 'Are you sure you want to delete this draft?'
        if (!window.confirm(msg)) return // eslint-disable-line no-alert
        dispatch(doDeleteDraft(ticketId, draftId))
      } else {
        dispatch(doUpdateEditorVisibility(false))
      }
      dispatch(doOpenTicketPage(ticketId))
    },
    debouncedHandleDraftChange: (ticketId, prop, val, opts) => {
      const fields = { isNote: true, [prop]: val }
      const { draftId } = opts
      const messageId = null // not used yet
      debouncedHandleDraftChange(
        dispatch,
        draftType,
        draftId,
        ticketId,
        messageId,
        fields
      )
    },
    handleDraftChange: (ticketId, prop, val, opts) => {
      const fields = { isNote: true, [prop]: val }
      const { draftId } = opts
      const messageId = null // not used yet
      handleDraftChange(
        dispatch,
        draftType,
        draftId,
        ticketId,
        messageId,
        fields
      )
    },
    sendDraft: (draftId, follow) => {
      dispatch(doSendReplyDraft(draftId, follow))
    },
    uploadFiles: (...args) => {
      dispatch(doUploadFiles(...args))
    },
    doEnsureDefaults: draftId => {
      dispatch(doEnsureDefaults(draftId, draftType))
    },
    doUpdateAgentMention: (...args) => {
      dispatch(doUpdateAgentMention(...args))
    },
    doMentionAgent: (...args) => {
      dispatch(doMentionAgent(...args))
    },
    doUpdateSuppressMentionSelector: (...args) => {
      dispatch(doUpdateSuppressMentionSelector(...args))
    },
    doRealtimeAgentStartTicketTypingNotification: (...args) => {
      dispatch(doRealtimeAgentStartTicketTypingNotification(...args))
    },
  }
}

export default connect(select, perform)(View)
